<template>
    <div class="error-message">
        <p>The requested report is not available. {{ message }}</p>
        <p>Please contact the Voluum account owner (administrator) who provided you with the report link.</p>
    </div>
</template>

<script>
export default {
    name: 'ErrorMessage',
    data: function() {
        return {
            message: this.$store.state.error ? `The following error occurred: ${this.$store.state.error}.` : null
        };
    }
};
</script>

<style>
    .error-message p {
        font-size: 1rem;
    }

    .error-message p:first-child {
        margin-top: 4rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/ErrorMessage.vue